import { AlternativeDetailsDialogViewModel } from '@Alternatives/Alternatives/Components/AlternativeDetailsDialog';
import AlternativeDetailsDialog from "@Alternatives/Alternatives/Components/AlternativeDetailsDialog.vue";
import { AttributeDescriptionDialogViewModel } from '@Alternatives/Attributes/Components/AttributeDescriptionDialog';
import AttributeDescriptionDialog from '@Alternatives/Attributes/Components/AttributeDescriptionDialog.vue';
import { DownloadBlob } from '@browser/Browser';
import * as rt from "@common/AppRT";
import { numCompare, strCompareLowerCase } from '@common/Common';
import PortfolioOrDecisionNavigation from '@common/Components/PortfolioOrDecisionNavigation.vue';
import { dynamicUiRoutes } from '@common/dynamicUiRoutes';
import { IEvaluationCommand } from '@Evaluation/cqrs';
import { DisagreementsDialogViewModel } from '@Evaluation/Estimations/Components/DisagreementsDialog';
import DisagreementsDialog from '@Evaluation/Estimations/Components/DisagreementsDialog.vue';
import HostVoteEditor from '@Evaluation/Estimations/Components/HostVoteEditor.vue';
import { MeetingStarterViewModel } from '@Evaluation/Estimations/Components/MeetingStarter';
import MeetingStarter from '@Evaluation/Estimations/Components/MeetingStarter.vue';
import { MeetingStopperViewModel } from '@Evaluation/Estimations/Components/MeetingStopper';
import MeetingStopper from '@Evaluation/Estimations/Components/MeetingStopper.vue';
import { PanelCloserViewModel } from '@Evaluation/Estimations/Components/PanelCloser';
import PanelCloser from '@Evaluation/Estimations/Components/PanelCloser.vue';
import { PanelOpenerViewModel } from '@Evaluation/Estimations/Components/PanelOpener';
import PanelOpener from '@Evaluation/Estimations/Components/PanelOpener.vue';
import { SurveyAccessLinksViewModel } from '@Evaluation/Estimations/Components/SurveyAccessLinks';
import SurveyAccessLinks from '@Evaluation/Estimations/Components/SurveyAccessLinks.vue';
import VotesBrowser from '@Evaluation/Estimations/Components/VotesBrowser.vue';
import { ClosePanelAccessCommandV1, OpenPanelAccessCommandV1, SaveGroupVoteCommandV1, SendEmailCommandV1 } from '@Evaluation/Estimations/Domain/commands-core';
import EstimationsCommands from "@Evaluation/Estimations/Domain/commands-vue-component";
import EstimationsQueries from "@Evaluation/Estimations/Domain/queries-vue-component";
import { ActiveQuestionReadModel, AlternativeReadModel, AttributeReadModel, DisagreementsReadModel, DownloadReadModel, HostQuestionListItemReadModel, MeetingManagerPageReadModel, PanelistReadModel } from '@Evaluation/Estimations/Domain/readmodels';
import { QuestionsOrder, SurveyVoteStatus } from '@Evaluation/Model';
import { Component, mixins } from 'vue-facing-decorator';


@Component({
    components:
    {
        PortfolioOrDecisionNavigation, HostVoteEditor, VotesBrowser,
        MeetingStarter, MeetingStopper, PanelOpener,
        PanelCloser, SurveyAccessLinks, AttributeDescriptionDialog,
        DisagreementsDialog, AlternativeDetailsDialog
    }
})
export default class MeetingManagerPage extends mixins(EstimationsCommands, EstimationsQueries)
{
    get workspaceId() { return Number.parseInt(this.$route.params.workspaceId); }
    get projectId() { return Number.parseInt(this.$route.params.projectId); }
    get surveyId(): number { return Number.parseInt(this.$route.params.surveyId) }

    initialized: boolean = false;
    handler: any = null;

    questionsCount: number = null;
    Name: string;
    Description: string;
    
    AlternativeLabel: string;
    AlternativesLabel: string;

    SearchPhrase: string = null;
    SwitchQuestionDebounceHandle: any = null;
    SavingCommentHandle: any = null;
    SavingValueHandle: any = null;

    Questions: HostQuestionListItemReadModel[] = [];
    Alternatives: AlternativeReadModel[] = [];
    Attributes: AttributeReadModel[] = [];
    panelists: PanelistReadModel[] = null;

    CurrentAttribute: AttributeReadModel = null;
    get CurrentAttributeLabel(): string { return this.CurrentAttribute?.Name; }

    CurrentAlternative: AlternativeReadModel = null;
    get CurrentAlternativeLabel(): string { return this.CurrentAlternative?.Name; }

    CurrentQuestionId: string = null;
    Question: ActiveQuestionReadModel = null;
    QuestionsOrder: QuestionsOrder = null;

    AutoRevealEnabled: boolean = false;
    NamesRevealed: boolean = true;
    VotesRevealed: boolean = false;

    MeetingStarted: boolean = false;
    SurveyStarted: boolean = null;

    meetingStarter = new MeetingStarterViewModel();
    meetingStopper = new MeetingStopperViewModel();

    panelOpener = new PanelOpenerViewModel();
    panelCloser = new PanelCloserViewModel();
    surveyAccessLinks = new SurveyAccessLinksViewModel();
    attributeDescriptionDialog = new AttributeDescriptionDialogViewModel();
    disagreementsDialog = new DisagreementsDialogViewModel();
    alternativeDetailsDialog = new AlternativeDetailsDialogViewModel();

    get BackUrl(): string { return dynamicUiRoutes.Evaluation_AssessmentsPanelsPage(this.$route, this.workspaceId, this.projectId); }
    get answeredQuestions() { return this.Questions.filter(a => a.Status !== SurveyVoteStatus.Empty); }
    get unansweredQuestions() { return this.Questions.filter(a => a.Status === SurveyVoteStatus.Empty); }

    get AllQuestionsAnswered(): boolean { return this.unansweredQuestions.length === 0; }
    get ProgressDescription(): string { return `${this.answeredQuestions.length} / ${this.questionsCount}`; }
    get QuestionsOrderLabel(): string { return this.QuestionsOrder === QuestionsOrder.ByAlternatives ? `By ${this.AlternativeLabel.toLowerCase()}` : "By attribute"; }


    get AlternativesView(): AlternativeReadModel[]
    {
        let view = this.Alternatives;

        const phrase = this.SearchPhrase?.toLowerCase();

        if (phrase)
        {
            view = view.filter(o => o.Name.toLowerCase().indexOf(phrase) >= 0);
        }

        return view;
    }

    get AttributesView(): AttributeReadModel[]
    {
        let view = this.Attributes;

        const phrase = this.SearchPhrase?.toLowerCase();

        if (phrase)
        {
            view = view.filter(o => o.Name.toLowerCase().indexOf(phrase) >= 0);
        }

        return view;
    }

    get QuestionsView(): HostQuestionListItemReadModel[]
    {
        if (this.QuestionsOrder === QuestionsOrder.ByAlternatives)
        {
            if (this.CurrentAlternative)
            {
                return this.Questions
                    .filter(q => q.AlternativeId === this.CurrentAlternative.AlternativeId)
                    .sort((a, b) => numCompare(a.OrderValueByAlternative, b.OrderValueByAlternative));
            }
        }
        else
        {
            if (this.CurrentAttribute)
            {
                return this.Questions
                    .filter(q => q.AttributeId === this.CurrentAttribute.AttributeId)
                    .sort((a, b) => numCompare(a.OrderValueByAttribute, b.OrderValueByAttribute));
            }
        }

        return [];
    }


    //

    saveComment(val: string | null)
    {
        this.Question.GroupVoteComment = val;

        if (this.SavingCommentHandle == null)
        {
            this.SavingCommentHandle = setTimeout(() =>
            {
                this.handleSaveGroupCommentCommand(this.Question.QuestionId, this.Question.GroupVoteComment);
                this.SavingCommentHandle = null;
            }, 1000);
        }
    }

    saveValue(val: number | null)
    {
        this.Question.GroupVoteValue = val;

        if (this.Question.HasScale)
        {
            this.handleSaveGroupVoteCommand(this.Question.QuestionId, this.Question.GroupVoteValue, this.Question.GroupVoteComment);
        }
        else
        {
            if (this.SavingValueHandle == null)
            {
                this.SavingValueHandle = setTimeout(() =>
                {
                    this.handleSaveGroupVoteCommand(this.Question.QuestionId, this.Question.GroupVoteValue, this.Question.GroupVoteComment);
                    this.SavingValueHandle = null;
                }, 1000);
            }
        }


    }

    //

    handleSaveGroupVoteCommand(questionId: string, value: number, comment: string)
    {
        this.invokeSaveGroupVoteCommandV1(this.workspaceId, this.surveyId, questionId, value, comment);
    }

    handleSaveGroupCommentCommand(questionId: string, comment: string)
    {
        this.invokeSaveGroupCommentCommandV1(this.workspaceId, this.surveyId, questionId, comment);
    }

    handleOpenPanelAccessCommand()
    {
        this.invokeOpenPanelAccessCommandV1(this.workspaceId, this.surveyId);
    }

    handleClosePanelAccessCommand()
    {
        this.invokeClosePanelAccessCommandV1(this.workspaceId, this.surveyId);
    }

    handleSendEmailCommand(e: any)
    {
        const recipientsIds = (e.Recipients as PanelistReadModel[]).map(a => a.ProjectUserId);
        this.invokeSendEmailCommandV1(this.workspaceId, this.surveyId, recipientsIds, e.EmailSubject, e.EmailBody);
    }

    downloadLinks()
    {
        this.runExportAccessLinksBySurveyIdQueryV1(this.workspaceId, this.surveyId);
    }

    StartMeeting()
    {
        this.MeetingStarted = true;
        this.publishMeetingStatus();
        this.meetingStarter.close();
    }

    StopMeeting()
    {
        this.MeetingStarted = false;
        this.publishMeetingStatus();

        this.meetingStopper.close();
    }


    SwitchQuestion(questionId: string)
    {
        this.Question = null;

        const q = this.Questions.find(a => a.QuestionId === questionId);
        this.CurrentQuestionId = q.QuestionId;
        this.CurrentAlternative = this.Alternatives.find(a => a.AlternativeId === q.AlternativeId);
        this.CurrentAttribute = this.Attributes.find(a => a.AttributeId === q.AttributeId);

        this.VotesRevealed = this.AutoRevealEnabled;

        this.runHostActiveQuestionQueryV1(this.workspaceId, this.surveyId, q.QuestionId);
    }

    NextQuestionCommand()
    {
        if (this.SwitchQuestionDebounceHandle == null)
        {
            const q = this.Questions.find(a => a.QuestionId === this.CurrentQuestionId);

            if (this.QuestionsOrder === QuestionsOrder.ByAlternatives)
            {
                const nextOrderValue = q.OrderValueByAlternative < this.Questions.length - 1 ? q.OrderValueByAlternative + 1 : 0;
                const nextQuestion = this.Questions.find(a => a.OrderValueByAlternative === nextOrderValue);

                this.SwitchQuestion(nextQuestion.QuestionId);
            }
            else
            {
                const nextOrderValue = q.OrderValueByAttribute < this.Questions.length - 1 ? q.OrderValueByAttribute + 1 : 0;
                const nextQuestion = this.Questions.find(a => a.OrderValueByAttribute === nextOrderValue);

                this.SwitchQuestion(nextQuestion.QuestionId);
            }

            this.SwitchQuestionDebounceHandle = setTimeout(() =>
            {
                clearTimeout(this.SwitchQuestionDebounceHandle);
                this.SwitchQuestionDebounceHandle = null;
            }, 600);
        }
    }

    NextUnansweredQuestionCommand()
    {
        if (this.SwitchQuestionDebounceHandle == null)
        {
            const q = this.Questions.find(a => a.QuestionId === this.CurrentQuestionId);

            if (this.QuestionsOrder === QuestionsOrder.ByAlternatives)
            {
                let questions = this.unansweredQuestions.filter(a => a.OrderValueByAlternative > q.OrderValueByAlternative);

                if (questions.length === 0)
                {
                    questions = this.unansweredQuestions.filter(a => a.OrderValueByAlternative < q.OrderValueByAlternative);
                }

                if (questions.length > 0)
                {
                    const q = questions.sort((a, b) => numCompare(a.OrderValueByAlternative, b.OrderValueByAlternative))[0];
                    this.SwitchQuestion(q.QuestionId);
                }
            }
            else
            {
                let questions = this.unansweredQuestions.filter(a => a.OrderValueByAttribute > q.OrderValueByAttribute);

                if (questions.length === 0)
                {
                    questions = this.unansweredQuestions.filter(a => a.OrderValueByAttribute < q.OrderValueByAttribute);
                }

                if (questions.length > 0)
                {
                    const q = questions.sort((a, b) => numCompare(a.OrderValueByAttribute, b.OrderValueByAttribute))[0];
                    this.SwitchQuestion(q.QuestionId);
                }
            }


            this.SwitchQuestionDebounceHandle = setTimeout(() =>
            {
                clearTimeout(this.SwitchQuestionDebounceHandle);
                this.SwitchQuestionDebounceHandle = null;
            }, 600);
        }
    }

    PreviousQuestionCommand()
    {
        if (this.SwitchQuestionDebounceHandle == null)
        {
            const q = this.Questions.find(a => a.QuestionId === this.CurrentQuestionId);

            if (this.QuestionsOrder === QuestionsOrder.ByAlternatives)
            {
                const prevOrderValue = q.OrderValueByAlternative > 0 ? q.OrderValueByAlternative - 1 : this.Questions.length - 1;
                const prevQuestion = this.Questions.find(a => a.OrderValueByAlternative === prevOrderValue);

                this.SwitchQuestion(prevQuestion.QuestionId);
            }
            else
            {
                const prevOrderValue = q.OrderValueByAttribute > 0 ? q.OrderValueByAttribute - 1 : this.Questions.length - 1;
                const prevQuestion = this.Questions.find(a => a.OrderValueByAttribute === prevOrderValue);

                this.SwitchQuestion(prevQuestion.QuestionId);
            }

            this.SwitchQuestionDebounceHandle = setTimeout(() =>
            {
                clearTimeout(this.SwitchQuestionDebounceHandle);
                this.SwitchQuestionDebounceHandle = null;
            }, 600);
        }
    }

    AllDoneCommand()
    {
        alert("Thanks! There are no other unanswered questions. You can close this page or continue reviewing your input.");
    }



    ShowMeetingStarterCommand()
    {
        this.VotesRevealed = false;
        this.AutoRevealEnabled = false;
        this.NamesRevealed = true;

        this.meetingStarter.show(this.SurveyStarted, this.AutoRevealEnabled, this.NamesRevealed);
    }

    ShowMeetingStopperCommand()
    {
        this.meetingStopper.show(this.SurveyStarted);
    }

    ShowSurveyOpenerCommand()
    {
        this.panelOpener.show(this.surveyId);
    }

    ShowSurveyCloserCommand()
    {
        this.panelCloser.show(this.surveyId);
    }

    ShowAccessLinksCommand()
    {
        this.surveyAccessLinks.show(this.surveyId);
        this.surveyAccessLinks.setData(this.panelists);
    }

    ShowDisagreementsReportCommand()
    {
        this.disagreementsDialog.show();
        this.runDisagreementsQueryV1(this.workspaceId, this.surveyId);
    }


    SwitchQuestionsOrderCommand()
    {
        if (this.QuestionsOrder === QuestionsOrder.ByCriteria)
        {
            this.QuestionsOrder = QuestionsOrder.ByAlternatives;
        }
        else
        {
            this.QuestionsOrder = QuestionsOrder.ByCriteria;
        }

        this.SearchPhrase = null;
    }

    SwitchToAttributeCommand(attr: AttributeReadModel)
    {
        this.CurrentAttribute = attr;
    }

    SwitchToAlternativeCommand(a: AlternativeReadModel)
    {
        this.CurrentAlternative = a;
    }

    SwitchToQuestionCommand(q: HostQuestionListItemReadModel)
    {
        this.SwitchQuestion(q.QuestionId);
    }


    ToggleAutoRevealCommand()
    {
        this.AutoRevealEnabled = !this.AutoRevealEnabled;

        if (this.AutoRevealEnabled && !this.VotesRevealed)
        {
            this.VotesRevealed = true;
            this.publishQuestionVotes();
        }
    }

    ToggleNamesRevealedCommand()
    {
        this.NamesRevealed = !this.NamesRevealed;
        this.publishQuestionVotes();
    }

    ToggleVotesRevealedCommand()
    {
        this.VotesRevealed = !this.VotesRevealed;

        if (!this.VotesRevealed && this.AutoRevealEnabled)
        {
            this.AutoRevealEnabled = false;
        }

        this.publishQuestionVotes();
    }


    ShowAlternativeDetailsCommand(alternativeId: number)
    {
        const alternative = this.Alternatives.find(a => a.AlternativeId === alternativeId);
        const detailsUrl = dynamicUiRoutes.Alternatives_AlternativeDashboardPage(this.$route, this.workspaceId, this.projectId, alternative.Id);
        this.alternativeDetailsDialog.show(alternative.Name, alternative.Description, detailsUrl);
    }

    ShowAttributeDetailsCommand(attrId: number)
    {
        const attr = this.Attributes.find(a => a.AttributeId === attrId);
        this.alternativeDetailsDialog.show(attr.Name, attr.Description);
    }

    getStatusCss(q: HostQuestionListItemReadModel): string | null
    {
        if (q.Status === SurveyVoteStatus.Empty)
        {
            return "fa fa-question-circle fg-color-red";
        }
        else if (q.Status === SurveyVoteStatus.Agg)
        {
            return "fa fa-check-circle fg-color-green";
        }
        else if (q.Status === SurveyVoteStatus.Manual)
        {
            return "fa fa-check-circle fg-color-orange";
        }

        return null;
    }


    SetVotesBrowserValue(questionId: string, projectUserId: number, value: number | null)
    {
        if (this.Question?.QuestionId === questionId)
        {
            this.Question.Entries.find(a => a.ProjectUserId === projectUserId).Value = value;

            const currQuestion = this.Questions.find(q => q.QuestionId === questionId);

            if (this.Question.Entries.some(v => v.Value != null))
            {
                if (currQuestion.Status === SurveyVoteStatus.Empty)
                {
                    currQuestion.Status = SurveyVoteStatus.Agg;
                }
            }
            else
            {
                if (currQuestion.Status === SurveyVoteStatus.Agg)
                {
                    currQuestion.Status = SurveyVoteStatus.Empty;
                }
            }
        }
    }

    SetVotesBrowserComment(questionId: string, projectUserId: number, comment: string)
    {
        if (this.Question?.QuestionId === questionId)
        {
            this.Question.Entries.find(a => a.ProjectUserId === projectUserId).Comment = comment;
        }
    }


    mounted()
    {
        this.handler = rt.subscribeModule("Estimations.MeetingManager",
            {
                PublishMeetingStatus: (data: any) =>
                {
                    if (this != null)
                    {
                        this.publishMeetingStatus();
                    }
                },
                UpdatePanelistVoteValue: (data: any) =>
                {
                    if (this != null)
                    {
                        this.SetVotesBrowserValue(data.QuestionId, data.ProjectUserId, data.Value);
                        this.publishPanelistVote(data.ProjectUserId, data.QuestionId);
                    }
                },
                UpdatePanelistVoteComment: (data: any) =>
                {
                    if (this != null)
                    {
                        this.SetVotesBrowserComment(data.QuestionId, data.ProjectUserId, data.Comment);
                        this.publishPanelistVote(data.ProjectUserId, data.QuestionId);
                    }
                },
            });

        this.runMeetingManagerPageQueryV1(this.surveyId);
    }

    onSetModel(model: any, modelName: string) 
    {
        if (modelName == "MeetingManagerPageReadModel")
        {
            const rm = model as MeetingManagerPageReadModel;

            this.Name = rm.SurveyName;
            this.questionsCount = rm.SurveyQuestionsCount;
            this.SurveyStarted = rm.SurveyStarted;
            
            this.AlternativeLabel = rm.AlternativeLabel;
            this.AlternativesLabel = rm.AlternativesLabel;
            this.panelists = rm.Panelists;
            this.QuestionsOrder = rm.QuestionsOrder;
            this.Alternatives = rm.Alternatives.sort((a, b) => strCompareLowerCase(a.Name, b.Name));
            this.Attributes = rm.Attributes.sort((a, b) => strCompareLowerCase(a.Name, b.Name));

            if (this.questionsCount > 0)
            {
                this.Questions = rm.Questions;
                this.Question = rm.ActiveQuestion;

                this.CurrentQuestionId = this.Question.QuestionId;
                this.CurrentAlternative = this.Alternatives.find(a => a.AlternativeId === this.Question.AlternativeId);
                this.CurrentAttribute = this.Attributes.find(a => a.AttributeId === this.Question.AttributeId);
            }

            this.initialized = true;
        }
        else if (modelName === "DownloadReadModel")
        {
            const rm = model as DownloadReadModel;
            DownloadBlob(rm.Url);
        }
        else if (modelName === "ActiveQuestionReadModel")
        {
            const rm = model as ActiveQuestionReadModel;
            this.Question = rm;

            const q = this.Questions.find(a => a.QuestionId === rm.QuestionId);
            q.Status = rm.Status;

            this.publishQuestion();
        }
        else if (modelName === "DisagreementsReadModel")
        {
            const rm = model as DisagreementsReadModel;
            this.disagreementsDialog.setData(rm.Items);
        }
    }

    onCommandSucceed(cmd: IEvaluationCommand, correlationId: string)
    {
        if (OpenPanelAccessCommandV1.matchType(cmd))
        {
            this.SurveyStarted = true;
            this.panelOpener.close();
            this.meetingStarter.surveyStarted = true;
            this.meetingStopper.surveyStarted = true;
        }
        else if (ClosePanelAccessCommandV1.matchType(cmd))
        {
            this.SurveyStarted = false;
            this.panelCloser.close();
            this.meetingStarter.surveyStarted = false;
            this.meetingStopper.surveyStarted = false;
        }
        else if (SaveGroupVoteCommandV1.matchType(cmd))
        {
            if (this.Question != null)
            {
                const q = this.Questions.find(a => a.QuestionId === this.Question.QuestionId);

                if (this.Question.GroupVoteValue != null)
                {
                    q.Status = SurveyVoteStatus.Manual;
                    q.GroupVoteValue = this.Question.GroupVoteValue;
                }
                else if (this.Question.Entries.some(e => e.Value != null))
                {
                    q.Status = SurveyVoteStatus.Agg;
                    q.GroupVoteValue = null;
                }
                else
                {
                    q.Status = SurveyVoteStatus.Empty;
                    q.GroupVoteValue = null;
                }
            }
        }
        else if (SendEmailCommandV1.matchType(cmd))
        {
            alert("Sent");
        }
    }


    publishMeetingStatus()
    {
        if (this.MeetingStarted === true)
        {
            rt.send("Estimations.MeetingManager", "PublishMeetingStarted",
                {
                    WorkspaceId: this.workspaceId,
                    SurveyId: this.surveyId,
                    Question: this.Question,
                    NamesRevealed: this.NamesRevealed,
                    VotesRevealed: this.VotesRevealed
                });
        }

        if (this.MeetingStarted === false)
        {
            rt.send("Estimations.MeetingManager", "PublishMeetingStopped",
                {
                    WorkspaceId: this.workspaceId,
                    SurveyId: this.surveyId,
                });
        }
    }

    publishQuestion()
    {
        if (this.MeetingStarted === true)
        {
            rt.send("Estimations.MeetingManager", "PublishMeetingQuestion",
                {
                    WorkspaceId: this.workspaceId,
                    SurveyId: this.surveyId,
                    Question: this.Question,
                    NamesRevealed: this.NamesRevealed,
                    VotesRevealed: this.VotesRevealed
                });
        }
    }

    publishQuestionVotes()
    {
        if (this.MeetingStarted === true)
        {
            rt.send("Estimations.MeetingManager", "PublishMeetingQuestionVotes",
                {
                    WorkspaceId: this.workspaceId,
                    SurveyId: this.surveyId,
                    Question: this.Question,
                    NamesRevealed: this.NamesRevealed,
                    VotesRevealed: this.VotesRevealed
                });
        }
    }

    publishPanelistVote(projectUserId: number, questionId: string)
    {
        if (this.MeetingStarted === true && this.VotesRevealed === true && this.Question.QuestionId === questionId)
        {
            const vote = this.Question.Entries.find(a => a.ProjectUserId === projectUserId);

            rt.send("Estimations.MeetingManager", "PublishMeetingPanelistVote",
                {
                    WorkspaceId: this.workspaceId,
                    SurveyId: this.surveyId,
                    ProjectUserId: projectUserId,
                    QuestionId: questionId,
                    VoteValue: vote?.Value,
                    VoteComment: vote?.Comment,
                });
        }
    }

    beforeDestroy()
    {
        if (this.handler)
        {
            rt.unsubscribe(this.handler);
        }
    }
}